import styled from 'styled-components';

import Button from '@components/Button/next';
import theme from '@utils/theme';

export const Layout = styled.div`
  max-width: 1240px;
  height: auto;
  margin: 0 auto;
  background-color: ${({ theme }) => theme.palette.white};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: calc(100% - 30px);
    margin-left: 15px;
    margin-right: 15px;
  }
`;

export const Left = styled.div`
  position: relative;
  width: 470px;
  height: auto;
  margin-top: 91px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    margin-top: 20px;
  }
`;

export const Right = styled.div`
  position: relative;
  width: calc(100% - 580px);
  margin-left: 110px;
  height: auto;
  margin-top: 41px;
  position: relative;
  background-color: ${({ theme }) => theme.palette.white};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    margin-left: 0px;
  }
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin-top: -15px;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    gap: 0;
  }
`;

export const StyledButton = styled(Button)<{ isTransparent?: boolean }>`
  && {
    width: 100%;
    height: 58px;
    font-size: 16px;
    font-weight: 700;
    margin-top: 10px;
    ${({ isTransparent, theme }) =>
      isTransparent &&
      `
   border-color:${theme.palette.eclipse};
   background: transparent;
   color: ${theme.palette.eclipse};
   &:hover,
   &:focus {
    background: transparent;
    border-color:${theme.palette.eclipse};
    background: transparent;
    color: ${theme.palette.eclipse};
    box-shadow: none;
   }
  `};
  }
`;

export const ClubTag = styled.div`
  padding: 10px;
  background-color: ${theme.palette.NL20};
  border-radius: 8px;
  margin-right: 10px;
`;
export const DynamicDiv = styled.div`
  display: flex;
  flex-direction: row;
`;

export const LayoutLogin = styled.div`
  max-width: 1370px;
  height: auto;
  margin: 0 auto;
  padding: 0 50px;
  background-color: ${({ theme }) => theme.palette.white};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: calc(100% - 30px);
    margin-left: 15px;
    margin-right: 15px;
    padding: 0 30px;
  }
`;

export const LeftLogin = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  margin-top: 21px;
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 470px;
    margin-top: 91px;
  }
`;

export const RightLogin = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  margin-top: 41px;
  position: relative;
  background-color: ${({ theme }) => theme.palette.white};
  @media ${({ theme }) => `(min-width: ${theme.breakPoint.LARGE_1X})`} {
    width: calc(100% - 580px);
    margin-left: 110px;
  }
`;

export const Register = styled.div`
  display: flex;
  flex-direction: row;
  text-align: center;
  margin-top: 20px;
  margin-bottom: 48px;
  justify-content: center;
  background-color: ${({ theme }) => theme.palette.white};
`;
export const Div = styled.div`
  display: flex;
  justify-content: center;
`;
